module.exports = __webpack_public_path__ + "static/media/Manual Skyworth ON VF.a8b0ebe7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Manual Skyworth ON VF.pdf
// module id = 319
// module chunks = 0